<!-- eslint-disable vue/no-deprecated-dollar-listeners-api -->
<template>
    <input
        type="button"
        class="btn"
        v-on="{ ...$listeners }"
    >
</template>

<script>
const Button = {
    name: "StyledButton"
}
export default Button;
</script>

<style scoped>
.btn {
    width: 100%;
    padding: 5px 15px;
    background-color: #4FD892;
    color: #122136;
    text-transform: uppercase;
    font-size: 18px;
    line-height: 25px;
    max-width: 226px;
    height: 45px;
    border: none;
    justify-self: end;
    cursor: pointer;
}

.btn:hover,
.btn:focus {
    filter: brightness(0.9);
}

.btn:active {
    filter: brightness(0.75);
}

.btn--exit {
    background-color: #fff;
    border: 1px solid #808080;
}
</style>